export enum PassCriteriaType {
  NONE,
  THRESHOLD,
  GRADES,
  PARTIAL_GRADES,
}
